import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import GetInTouch from '../components/GetInTouch';
import About from '../components/Home/About';
import CaseStudies from '../components/Home/CaseStudies';
import Hero from '../components/Home/Hero';
import Reviews from '../components/Home/Reviews';

const Home = () => {
    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet='utf-8' />
                <title>Home | Christian Reuben</title>
                <link rel='canonical' href='https://christianreuben.com/' />
                <meta
                    name='description'
                    content='Christian is an Entrepreneur and Adviser that helps companies simplify challenges, build productive teams and grow seamlessly; he shepherds a team that helps companies grow seamlessly, through analysis of the current challenges (in-depth research of current problems), collaboratively working with current teams in creating a strategy road map for business growth + then sharing the road map to help companies thrive + implementing plans.'
                />
                <meta
                    name='keywords'
                    content='Christian Reuben, Christian, Entrepreneur, Adviser, People Engineer, Writer, Speaker, Business, bluesense, Consulting, Startups, Tech Startups, Strategy, BlueSense, Business Consulting'
                />
            </Helmet>
            <main id='home'>
                <Hero />
                <About />
                <Reviews />
                <CaseStudies />
                <GetInTouch />
            </main>
        </HelmetProvider>
    );
};

export default Home;
